export default __webpack_public_path__ + "locales/ru/EmptyTrashDialog.json?hash=1bf237509b54bc58d0c5789acef52d25";